import StatCard from "../Dashboard/StatCard";
import { brand } from "../../theme/tokens";

/**
 * Thẻ số dạng phẳng — cùng hình dạng với `Dashboard/StatCard`, chỉ khác cách truyền
 * tham số (rời từng prop thay vì gói trong một object `stat`).
 *
 * Trước đây hai file này tự vẽ riêng nên dải thẻ ở mỗi màn một chiều cao, dù trông
 * na ná nhau. Giờ chỉ còn MỘT chỗ vẽ; ở đây chỉ đổi tên tham số.
 *
 * @example <MetricCard icon={<UserOutlined />} color={brand.accent} label="Tổng hội thoại" value={42} />
 */
export default function MetricCard({ icon, color = brand.accent, label, value, suffix = "" }) {
  return (
    <StatCard
      stat={{
        icon,
        color,
        title: label,
        value: (value ?? 0).toLocaleString("vi-VN"),
        suffix,
      }}
    />
  );
}
